//#region src/assets/vana-card-blue-dark.svg
var vana_card_blue_dark_default = "" + new URL("vana-card-blue-dark-DGYssHyG.svg", import.meta.url).href;
//#endregion
export { vana_card_blue_dark_default as default };

//# sourceMappingURL=vana-card-blue-dark.js.map